import React from "react";

export const Header: React.FC = () => {
  return (
    <h1 style={{ textAlign: "center" }}>
      Expense Tracker with Push Notifications
    </h1>
  );
};
